import { MoreHoriz } from '@mui/icons-material';
import { IconButton, styled, MenuList } from '@mui/material';
import { ReactElement } from 'react';

import { Dropdown, DropdownProps } from '../display';

const StyledMenuList = styled(MenuList)({
  minWidth: 200,
});

type Props = { children: React.ReactNode };

export const BaseHeaderActionsMenu = ({ children }: Props): ReactElement => {
  return (
    <Dropdown
      size="small"
      menuListProps={{
        component: StyledMenuList,
        disablePadding: true,
      }}
      placement="bottom-end"
      renderButton={({ onClick }: DropdownProps) => (
        <IconButton onClick={onClick} aria-label="instance menu options" size="xsmall">
          <MoreHoriz />
        </IconButton>
      )}
    >
      {children}
    </Dropdown>
  );
};
